export function capitalizeFirstLetter(word: string) {
  if (!word) return word;
  const [first, ...rest] = word;

  return `${first.toUpperCase()}${rest.join('')}`;
}
